import { render } from "./ThemeTypography.vue?vue&type=template&id=9e11b06a&scoped=true"
import script from "./ThemeTypography.vue?vue&type=script&lang=js"
export * from "./ThemeTypography.vue?vue&type=script&lang=js"

import "./ThemeTypography.vue?vue&type=style&index=0&id=9e11b06a&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/G23/web-portal/bia-webportal-prod/bia-cms-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e11b06a"]])

export default __exports__